import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = ["value"];
const _hoisted_4 = { class: "text-center" };
const _hoisted_5 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "taskTitle" }, " Seleziona il template da inviare ", -1)),
        _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedName) = $event))
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateNames, (item) => {
                    return (_openBlock(), _createElementBlock("option", { value: item }, _toDisplayString(item), 9, _hoisted_3));
                }), 256))
            ], 512), [
                [_vModelSelect, _ctx.selectedName]
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.ok && _ctx.ok(...args))),
                disabled: !_ctx.selectedName
            }, "Avanti", 8, _hoisted_5)
        ])
    ]));
}
